import calculateExactMinsForBooking from "./calculateExactMinsForBooking";
import formatDate from "./formatDate";

export default function getDateAndTimeOfBooking({ activityType, bookingData }) {
  if (!bookingData) return "";

  const divisions = normalizeDivisions(activityType?.slotsPerHour);
  const formattedDate = bookingData.date
    ? formatDate(bookingData.date, true)
    : "-";
  const formattedHour = formatHour(bookingData.hour);
  const minuteMark = calculateExactMinsForBooking({
    divisions,
    mark: normalizeSlot(bookingData.slot),
  });

  return `${formattedDate} @ ${formattedHour}:${minuteMark}`;

  function formatHour(num) {
    if (num === null || num === undefined || Number.isNaN(Number(num))) {
      return "00";
    }
    if (num < 10) return `0${num}`;
    return num;
  }
}

function normalizeDivisions(value) {
  let parsed = parseInt(value);
  if (Number.isNaN(parsed) || parsed < 1) return 1;
  return parsed;
}

function normalizeSlot(value) {
  let parsed = parseInt(value);
  if (Number.isNaN(parsed) || parsed < 1) return 1;
  return parsed;
}
